<template>
  <div>
    <articles-table ref="articlesTable" :operateColumns="operateColumns" :headColumns="headColumns"></articles-table>
    <Modal class="article-modal" :title="selectArticle.title" v-model="articleDetailVisible" width="1000">
      <div v-html="articleData" style="padding:0 10px;"></div>
      <div slot="footer"></div>
    </Modal>
    <Modal title="公告审核" v-model="articleExamineVisible">
      <div style="margin: 10px 0;">
        <span>审核公告：</span>
        <span>{{selectArticle.title}}</span>
      </div>
      <span>审核结果：</span>
      <Select v-model="examineResult" style="width: 200px;">
        <Option :value="1">审核通过</Option>
        <Option :value="2">审核不通过</Option>
      </Select>
      <div v-if="examineResult===2" style="margin: 10px 0;">
        <span>驳回原因：</span>
        <Input v-model="unPassReason" style="width:400px;"></Input>
      </div>
      <div slot="footer">
        <Button @click="articleExamineVisible=false">取消</Button>
        <Button @click="examineConfirm" type="primary">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import ArticlesTable from '@/components/articlesTable'
import { formatDate } from '@/lib/tool'

export default {
  name: 'articleExamine',
  components: {
    ArticlesTable,
  },
  data() {
    return {
      headColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        }
      ],
      operateColumns: [
        {
          title: '状态',
          width: 80,
          render: (h, params) => {
            let status = '无'
            switch(params.row.status) {
              case '1':
                status = '通过'
                break
              case '2':
                status = '不通过'
                break
              case '0':
                status = '待审核'
                break
            }
            return h('div', status)
          }
        },
        {
          title: '操作',
          width: 145,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  size: 'small',
                  type: 'primary'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.selectArticle = params.row
                    this.viewArticle(params.row)
                  }
                }
              }, '详情'),
              h('Button', {
                props: {
                  size: 'small',
                  type: 'primary'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.examineResult = 1
                    this.unPassReason = ''
                    this.selectArticle = params.row
                    this.articleExamineVisible = true
                  }
                }
              }, '审核'),
              // h('Button', {
              //   props: {
              //     size: 'small',
              //     type: 'primary'
              //   },
              //   on: {
              //     click: () => {
              //       this.selectArticle = params.row
              //       window.open(`${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B9879%5D%5B76ee%5D%5B516c%5D%5B544a%5D%5B5ba1%5D%5B67e5%5D%5B60c5%5D%5B51b5%5D%5B8868%5D%2FProjectCheck.cpt&ggid=${params.row.id}`)
              //     }
              //   }
              // }, '审核报表'),
            ])
          }
        }
      ],
      articleDetailVisible: false,
      articleData: '',
      selectArticle: {},
      articleExamineVisible: false,
      examineResult: 1,
      unPassReason: '',
    }
  },
  methods: {
    async viewArticle(article = '') {
      this.$Spin.show()
      try {
        let rep = await ajax.get(requestUrls.articlesData.GetArticleDataByAIdAsync, {
          params: {
            aId: article.id
          }
        })
        this.$Spin.hide()
        if (rep.data.success) {
          this.articleData = rep.data.result.content
          this.articleDetailVisible = true
        } else {
          this.$Message.error('查询公告失败')
        }
      } catch (err) {
        this.$Spin.hide()
        console.error(err)
        this.$Message.error('查询公告失败')
      }
    },
    examineConfirm() {
      // 审核通过
      if (this.examineResult === 1) {
        this.$Modal.confirm({
          title: '通过',
          content: '确定此公告审核通过？',
          onOk: async () => {
            this.$Spin.show()
            try {
              let rep = await ajax.post(requestUrls.articles.ArticlesStatusUpdate, [{
                id: this.selectArticle.id,
                status: 1,
                opinion: '通过',
                checkTime: formatDate(),
                checkUser: this.$store.state.session.user.name
              }])
              this.$Spin.hide()
              if (rep.data.success) {
                this.$Message.success('操作成功')
                // 刷新数据
                this.$refs.articlesTable.refreshArticles()
              } else {
                this.$Message.error('操作失败')
              }
            } catch(err) {
              console.error(err)
              this.$Spin.hide()
              this.$Message.error('操作失败')
            }
          }
        })
      }
      // 审核不通过
      if (this.examineResult === 2) {
        if (this.unPassReason === '') {
          this.$Message.info('驳回原因不能为空')
          return
        }
        this.$Modal.confirm({
          title: '审核不通过',
          content: '确定此公告审核不通过？',
          onOk: async () => {
            this.$Spin.show()
            try {
              let rep = await ajax.post(requestUrls.articles.ArticlesStatusUpdate, [{
                id: this.selectArticle.id,
                status: 2,
                opinion: this.unPassReason,
                checkTime: formatDate(),
                checkUser: this.$store.state.session.user.name
              }])
              this.$Spin.hide()
              if (rep.data.success) {
                this.$Message.success('操作成功')
                // 刷新数据
                this.$refs.articlesTable.refreshArticles()
              } else {
                this.$Message.error('操作失败')
              }
            } catch(err) {
              console.error(err)
              this.$Message.error('操作失败')
            }
          }
        })
      }
    },
  }
}
</script>

<style lang="less">
.article-modal {
  .ivu-modal {
    top: 50px;
  }
}
</style>

